<template>
  <div v-if="!paramNovoIb" class="tela-bloqueio">
    <v-container fluid>
      <v-row justify="center" class="pa-10">
        <ImagemComFallback
          :src="logoImg"
          srcDefault="/assets/imgs/logo.svg"
          max-width="150"
        />
      </v-row>
      <v-row justify="center">
        <p class="titleBloqueio">Acesso pelo celular</p>
      </v-row>
      <v-row justify="center">
        <p class="subtitleBloqueio">O cadastro de biometria está disponível apenas pelo celular.</p>
      </v-row>
      <v-row justify="center">
        <p class="subtitle2Bloqueio">Acesse esse link em seu celular para prosseguir com o processo.</p>
      </v-row>
      <v-row justify="center" class="pb-0 mb-0">
        <p class="detailBloqueio">Em caso de dúvidas, entre em contato pelos nossos canais de atendimento:</p>
      </v-row>
      <v-row justify="center" class="pt-0">
        <p class="contactsBloqueio pr-1">Telefone:</p><p class="contactsHighlightBloqueio">{{ dadosContato?.Telefone || '(11) 4858-8650' }}</p>
        <p class="contactsBloqueio pl-1 pr-1">| E-mail:</p> <p class="contactsHighlightBloqueio">{{ dadosContato?.Email || 'atendimento@moneyp.com.br'}}</p>
      </v-row>
    </v-container>
  </div>
  <div v-else>
    <v-container fluid>
      <v-row justify="center" class="pa-10">
        <ImagemComFallback
          :src="logoImg"
          srcDefault="/assets/imgs/logo.svg"
          max-width="150"
        />
      </v-row>
      <v-row justify="center">
        <p class="titleBloqueio">Validação biométrica</p>
      </v-row>
      <v-row justify="center">
        <p class="subtitleBloqueio">O cadastro da biometria deve ser realizado pelo seu smartphone. </p>
      </v-row>
      <v-row justify="center">
        <p class="subtitle2Bloqueio">Clique no link enviado para o seu e-mail, ou aponte a câmera do seu celular para o QR code ao lado.</p>
      </v-row>
      <v-row justify="center" class="pa-5">
        <div class="canvas">
          <div ref="qrCodeContainer"></div>
        </div>
      </v-row>
      <v-row justify="center" class="pb-0 mb-0">
        <p class="detailBloqueio">Em caso de dúvidas, entre em contato pelos nossos canais de atendimento:</p>
      </v-row>
      <v-row justify="center" class="pt-0">
        <p class="contactsBloqueio pr-1">Telefone:</p><p class="contactsHighlightBloqueio">{{ dadosContato?.Telefone || '(11) 4858-8650' }}</p>
        <p class="contactsBloqueio pl-1 pr-1">| E-mail:</p> <p class="contactsHighlightBloqueio">{{ dadosContato?.Email || 'atendimento@moneyp.com.br'}}</p>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import QRCodeStyling from 'qr-code-styling';

export default {
  data () {
    return {
      dadosContato: null,
      params: JSON.parse(localStorage.getItem('params')),
      logoImg: this.$theme.logo,
      isQrCodeLoaded: false
    }
  },
  methods: {
    async loadQRCode () {
      const options = {
        width: 268,
        height: 268,
        type: 'svg',
        data: this.params.qrData,
        image: this.logoImg,
        imageOptions: {
          crossOrigin: 'anonymous',
          margin: 5
        }
      };

      if (this.$refs.qrCodeContainer) {
        this.$refs.qrCodeContainer.innerHTML = '';
      }

      const qrCode = new QRCodeStyling(options);
      qrCode.append(this.$refs.qrCodeContainer);
      setTimeout(() => {
        this.verifyQrCode(() => {
          this.loadQRCode();
        });
      }, 300);
    },
    verifyQrCode (callback) {
      this.isQrCodeLoaded = this.$refs.qrCodeContainer?.children.length > 0;
      if (!this.isQrCodeLoaded) {
        callback();
      }
    },
  },
  computed: {
    paramNovoIb () {
      return this.$store.state.onboarding.paramNovoIb
    }
  },
  mounted () {
    this.loadQRCode();
    const dadosContato = localStorage.getItem('dadosContato')
    this.dadosContato = JSON.parse(dadosContato)
  }
}
</script>

<style scoped>
.titleBloqueio {
  font-family: Roboto !important;
  font-weight: 400;
  font-size: 30px;
  line-height: 35.16px;
  color: #2171BD;
}

.subtitleBloqueio {
  font-family: Roboto !important;
  font-weight: 500;
  font-size: 18px;
  line-height: 21.09px;
  color: var(--v-customColor_IB-base);
}

.subtitle2Bloqueio {
  font-family: Roboto !important;
  font-weight: 400;
  font-size: 18px;
  line-height: 21.09px;
  color: var(--v-customColor_IB-base);
}

.infoBloqueio {
  font-family: Roboto !important;
  font-weight: 700;
  font-size: 14px;
  line-height: 16.41px;
  color: #3B3D55;
  background-color: white !important;
}

.contactsBloqueio {
  font-family: Roboto !important;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.41px;
  color: #3B3D55;
  background-color: white !important;
}

.contactsHighlightBloqueio {
  font-family: Roboto !important;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.41px;
  color: #096DD9;
  background-color: white !important;
}

.canvas{
  width: 268px !important;
  height: 268px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
}

.loading-container {
  display: flex;
  justify-content: space-between;
  width: 60px;
  margin-top: -20px !important;
}

.loading-point {
  width: 10px;
  height: 10px;
  background-color: var(--v-secondary-base);
  border-radius: 50%;
  animation: bounce 1.5s infinite ease-in-out;
  background-color: var(--v-customColor_IB-base);
}

.loading-point:nth-child(1) {
  animation-delay: 0s;
}

.loading-point:nth-child(2) {
  animation-delay: 0.5s;
}

.loading-point:nth-child(3) {
  animation-delay: 1s;
}

.tela-bloqueio {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

@keyframes bounce {
  0%, 20%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}
</style>
